import { render, staticRenderFns } from "./ActiveOutbreaks.vue?vue&type=template&id=9e220d32&scoped=true&"
import script from "./ActiveOutbreaks.vue?vue&type=script&lang=js&"
export * from "./ActiveOutbreaks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e220d32",
  null
  
)

export default component.exports